// extracted by mini-css-extract-plugin
module.exports = {"navigationButton":"navigation-button_navigationButton__fZyjF"};